/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_Sync_DescInputs */



/**
* | output |
* | --- |
* | "Everyone plays the same round together, then the next one starts." |
*
* @param {Tournament_Wiz_Kind_Sync_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_sync_desc = /** @type {((inputs?: Tournament_Wiz_Kind_Sync_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_Sync_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout le monde joue la même ronde ensemble, puis la suivante commence.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos juegan la misma ronda a la vez y después empieza la siguiente.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos jogam a mesma rodada juntos e depois começa a seguinte.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti giocano lo stesso round insieme, poi inizia il successivo.")
	return /** @type {LocalizedString} */ ("Everyone plays the same round together, then the next one starts.")
});